/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="16.61" height="61.71" viewBox="0 0 16.61 61.71" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <polyline points="15.89 61.35 0.89 31.3 15.89 0.35" stroke="#8a8a8a" className="icon-stroke" strokeWidth="1.6"/>
      </svg>

    );
  }
}

Icon.displayName = 'ChevronLeftNarrowIcon';

export default Icon;
